import { generatedAssumptionImpactLedger } from "./generatedAssumptionImpactLedger.js";
import { generatedAsteroidCandidateEvidenceLedger } from "./generatedAsteroidCandidateEvidenceLedger.js";
import { generatedBetaClosureStatus } from "./generatedBetaClosureStatus.js";
import { generatedBusinessPlatformRoadmap } from "./generatedBusinessPlatformRoadmap.js";
import { generatedCapabilityMaturityLedger } from "./generatedCapabilityMaturityLedger.js";
import { generatedClaimEvidenceLedger } from "./generatedClaimEvidenceLedger.js";
import { generatedCustomerReportPacketLedger } from "./generatedCustomerReportPacketLedger.js";
import { generatedEconomicsEvidenceLedger } from "./generatedEconomicsEvidenceLedger.js";
import { generatedEconomicsFrontierReport } from "./generatedEconomicsFrontier.js";
import { generatedEvidenceGapPriorityLedger } from "./generatedEvidenceGapPriorityLedger.js";
import { generatedFeasibilityReport } from "./generatedFeasibilityReport.js";
import { generatedMaterialsProcessEvidenceLedger } from "./generatedMaterialsProcessEvidenceLedger.js";
import { generatedModelArtifactBundle } from "./generatedModelArtifacts.js";
import { generatedModelRunLedger } from "./generatedModelRunLedger.js";
import { generatedModelValidationProtocolLedger } from "./generatedModelValidationProtocols.js";
import { generatedPromotionClosureLedger } from "./generatedPromotionClosureLedger.js";
import { generatedReleaseEvidenceLedger } from "./generatedReleaseEvidenceLedger.js";
import { generatedResearchPackageManifest } from "./generatedResearchPackageManifest.js";
import { generatedRuntimeClosurePacket } from "./generatedRuntimeClosurePacket.js";
import { generatedRuntimeValidationCampaignLedger } from "./generatedRuntimeValidationCampaignLedger.js";
import { generatedScenarioComparisonBoard } from "./generatedScenarioComparisonBoard.js";
import { generatedScenarioCrossoverFrontierLedger } from "./generatedScenarioCrossoverFrontier.js";
import { generatedScenarioDecisionAuditLedger } from "./generatedScenarioDecisionAuditLedger.js";
import { generatedScenarioDecisionLedger } from "./generatedScenarioDecisionLedger.js";
import { generatedScenarioNotebookPack } from "./generatedScenarioNotebookPack.js";
import { generatedScenarioTraceabilityMatrix } from "./generatedScenarioTraceabilityMatrix.js";
import { generatedSidecarArtifactTemplatePacket } from "./generatedSidecarArtifactTemplates.js";
import { generatedSidecarPromotionLedger } from "./generatedSidecarPromotionLedger.js";
import { generatedSidecarReadinessLedger } from "./generatedSidecarReadinessLedger.js";
import { generatedSidecarRunSpecPacket } from "./generatedSidecarRunSpecs.js";
import { generatedSidecarValidationReport } from "./generatedSidecarValidationReport.js";
import { generatedSidecarWorkOrderPacket } from "./generatedSidecarWorkOrders.js";
import { generatedSourceIngestionLedger } from "./generatedSourceIngestionLedger.js";
import { generatedSourcePromotionLedger } from "./generatedSourcePromotionLedger.js";
import { generatedSourceRefreshReport } from "./generatedSourceRefreshReport.js";
import { generatedSourceUseClearanceDossier } from "./generatedSourceUseClearanceDossier.js";
import { generatedSourceUseReviewPacket } from "./generatedSourceUseReviewPackets.js";
import { generatedSourceUseRightsLedger } from "./generatedSourceUseRightsLedger.js";
import { generatedSpaceEnvironmentEvidenceLedger } from "./generatedSpaceEnvironmentEvidenceLedger.js";
import { generatedTrajectoryValidationMatrix } from "./generatedTrajectoryValidationMatrix.js";
import { generatedWorkspaceLedger } from "./generatedWorkspaceLedger.js";
import { buildFeasibilityReport } from "../science/report.mjs";

export function appExportFilenames(buildId) {
  return {
    scenarioSnapshot: `inner-solar-scenario-snapshot-${buildId}.json`,
    feasibilityReport: `interplanetary-feasibility-report-${buildId}.json`,
    researchPackages: `interplanetary-research-packages-${buildId}.json`,
  };
}

export function buildScenarioSnapshotExportPayload({
  build,
  exportedAt,
  selectedScenarioId,
  scenarioSet,
  horizonYears,
  capitalUsdBn,
  launchMassT,
  weights,
  rankedScenarios,
  paretoFrontier,
  businessCases,
  uncertaintyAnalysis,
  selectedScenario,
  sources,
  claims,
  formulas,
  scenarios,
  sourceRegistryV2,
  modelArtifacts,
  assumptionRegistry,
}) {
  return {
    build,
    exportedAt,
    selectedScenarioId,
    scenarioSet,
    horizonYears,
    capitalUsdBn,
    launchMassT,
    weights,
    rankedScenarios,
    paretoFrontier,
    businessCases,
    uncertaintyAnalysis,
    selectedScenario,
    evidenceCounts: {
      sources: sources.length,
      sourceRegistryV2: sourceRegistryV2.length,
      claims: claims.length,
      formulas: formulas.length,
      scenarios: scenarios.length,
      modelArtifacts: modelArtifacts.length,
      assumptions: assumptionRegistry.length,
      scenarioNotebooks: generatedScenarioNotebookPack.notebookCount,
      researchPackages: generatedResearchPackageManifest.packageCount,
      economicsFrontierScenarios: generatedEconomicsFrontierReport.scenarioSummaries.length,
      evidenceGaps: generatedEvidenceGapPriorityLedger.gapCount,
      validationProtocols: generatedModelValidationProtocolLedger.protocolCount,
      decisionAudits: generatedScenarioDecisionAuditLedger.auditCount,
      crossoverFrontiers: generatedScenarioCrossoverFrontierLedger.challengerCount,
      materialsProcessRecords: generatedMaterialsProcessEvidenceLedger.processCount,
      spaceEnvironmentRecords: generatedSpaceEnvironmentEvidenceLedger.recordCount,
      scenarioTraceabilityRows: generatedScenarioTraceabilityMatrix.scenarioCount,
      sidecarWorkOrders: generatedSidecarWorkOrderPacket.workOrderCount,
      sidecarRunSpecs: generatedSidecarRunSpecPacket.specCount,
      sidecarArtifactTemplates: generatedSidecarArtifactTemplatePacket.templateCount,
      sidecarReadinessContracts: generatedSidecarReadinessLedger.contractCount,
      runtimeValidationCampaigns: generatedRuntimeValidationCampaignLedger.campaignCount,
      runtimeClosureRecords: generatedRuntimeClosurePacket.contractCount,
      trajectoryValidationRows: generatedTrajectoryValidationMatrix.rowCount,
      trajectoryValidationBlocked: generatedTrajectoryValidationMatrix.blockedRowCount,
      sourceIngestionWorkOrders: generatedSourceIngestionLedger.workOrderCount,
      sourcePromotions: generatedSourcePromotionLedger.promotedCount,
      sourceUseClearanceClasses: generatedSourceUseClearanceDossier.classCount,
      sourceUseClearanceBlocked: generatedSourceUseClearanceDossier.blockedSourceCount,
      sourceUseReviewPackets: generatedSourceUseReviewPacket.packetCount,
      sourceUseRightsBlocked: generatedSourceUseRightsLedger.blockedSourceUseCount,
      roadmapCapabilities: generatedBusinessPlatformRoadmap.capabilityCount,
      roadmapBlockedCapabilities: generatedBusinessPlatformRoadmap.blockedCapabilityCount,
      sidecarPromotions: generatedSidecarPromotionLedger.promotedCount,
      releaseGates: generatedReleaseEvidenceLedger.gateCount,
      betaClosureBlockers: generatedBetaClosureStatus.blockerCount,
    },
    sourceRegistryV2,
    modelArtifacts,
    assumptionRegistry,
    scenarioNotebookPack: generatedScenarioNotebookPack,
    generatedEconomicsFrontierReport,
    generatedMaterialsProcessEvidenceLedger,
    generatedSpaceEnvironmentEvidenceLedger,
    generatedModelValidationProtocolLedger,
    generatedScenarioDecisionAuditLedger,
    generatedScenarioCrossoverFrontierLedger,
    generatedEvidenceGapPriorityLedger,
    generatedScenarioTraceabilityMatrix,
    generatedSourceIngestionLedger,
    generatedSourcePromotionLedger,
    generatedSourceUseClearanceDossier,
    generatedSourceUseReviewPacket,
    generatedSourceUseRightsLedger,
    generatedBusinessPlatformRoadmap,
    generatedSidecarWorkOrderPacket,
    generatedSidecarRunSpecPacket,
    generatedSidecarArtifactTemplatePacket,
    generatedSidecarReadinessLedger,
    generatedRuntimeValidationCampaignLedger,
    generatedRuntimeClosurePacket,
    generatedTrajectoryValidationMatrix,
    generatedSidecarPromotionLedger,
    generatedResearchPackageManifest,
    generatedReleaseEvidenceLedger,
    generatedBetaClosureStatus,
  };
}

export function buildFeasibilityReportExportPayload({
  build,
  generatedAt,
  selectedScenarioId,
  scenarioSet,
  horizonYears,
  capitalUsdBn,
  launchMassT,
  rankedScenarios,
  uncertaintyAnalysis,
  businessCases,
  frontier,
  sourceRegistryV2,
  claims,
  modelArtifacts,
  assumptionRegistry,
  readinessCategories,
}) {
  return buildFeasibilityReport({
    build,
    generatedAt,
    selectedScenarioId,
    inputs: {
      scenarioSet,
      horizonYears,
      capitalUsdBn,
      launchMassT,
    },
    rankedScenarios,
    uncertaintyAnalysis,
    businessCases,
    frontier,
    sourceRegistryV2,
    claims,
    modelArtifacts,
    generatedAsteroidCandidateEvidenceLedger,
    generatedClaimEvidenceLedger,
    generatedCapabilityMaturityLedger,
    generatedModelValidationProtocolLedger,
    generatedModelArtifactBundle,
    generatedModelRunLedger,
    generatedEconomicsFrontierReport,
    generatedEconomicsEvidenceLedger,
    generatedMaterialsProcessEvidenceLedger,
    generatedSpaceEnvironmentEvidenceLedger,
    generatedAssumptionImpactLedger,
    generatedScenarioDecisionLedger,
    generatedScenarioDecisionAuditLedger,
    generatedScenarioCrossoverFrontierLedger,
    assumptionRegistry,
    scenarioNotebooks: generatedScenarioNotebookPack.notebooks,
    generatedScenarioNotebookPack,
    readinessCategories,
    generatedSidecarValidationReport,
    generatedSidecarWorkOrderPacket,
    generatedSourceIngestionLedger,
    generatedSourceUseClearanceDossier,
    generatedSourceUseReviewPacket,
    generatedSourceUseRightsLedger,
    generatedWorkspaceLedger,
  });
}

export function buildResearchPackagesExportPayload({ build, exportedAt }) {
  return {
    build,
    exportedAt,
    manifest: generatedResearchPackageManifest,
    packageCount: generatedResearchPackageManifest.packageCount,
    blockedPackageCount: generatedResearchPackageManifest.blockedPackageCount,
    linkedArtifacts: {
      feasibilityReportHash: generatedFeasibilityReport.reportHash,
      asteroidCandidateEvidenceLedgerHash: generatedAsteroidCandidateEvidenceLedger.ledgerHash,
      capabilityMaturityLedgerHash: generatedCapabilityMaturityLedger.ledgerHash,
      claimEvidenceLedgerHash: generatedClaimEvidenceLedger.ledgerHash,
      assumptionImpactLedgerHash: generatedAssumptionImpactLedger.ledgerHash,
      scenarioDecisionLedgerHash: generatedScenarioDecisionLedger.ledgerHash,
      scenarioDecisionAuditLedgerHash: generatedScenarioDecisionAuditLedger.ledgerHash,
      scenarioCrossoverFrontierHash: generatedScenarioCrossoverFrontierLedger.ledgerHash,
      scenarioTraceabilityMatrixHash: generatedScenarioTraceabilityMatrix.matrixHash,
      evidenceGapPriorityLedgerHash: generatedEvidenceGapPriorityLedger.ledgerHash,
      promotionClosureLedgerHash: generatedPromotionClosureLedger.ledgerHash,
      economicsFrontierHash: generatedEconomicsFrontierReport.reportHash,
      economicsEvidenceLedgerHash: generatedEconomicsEvidenceLedger.ledgerHash,
      materialsProcessEvidenceLedgerHash: generatedMaterialsProcessEvidenceLedger.ledgerHash,
      spaceEnvironmentEvidenceLedgerHash: generatedSpaceEnvironmentEvidenceLedger.ledgerHash,
      modelRunLedgerHash: generatedModelRunLedger.ledgerHash,
      workspaceLedgerHash: generatedWorkspaceLedger.ledgerHash,
      modelArtifactBundleHash: generatedModelArtifactBundle.bundleHash,
      modelValidationProtocolLedgerHash: generatedModelValidationProtocolLedger.ledgerHash,
      sourceRefreshReportHash: generatedSourceRefreshReport.reportHash,
      sourceIngestionLedgerHash: generatedSourceIngestionLedger.ledgerHash,
      sourceUseReviewPacketHash: generatedSourceUseReviewPacket.packetHash,
      sourceUseRightsLedgerHash: generatedSourceUseRightsLedger.ledgerHash,
      sourceUseClearanceDossierHash: generatedSourceUseClearanceDossier.dossierHash,
      businessPlatformRoadmapHash: generatedBusinessPlatformRoadmap.roadmapHash,
      sourcePromotionLedgerHash: generatedSourcePromotionLedger.ledgerHash,
      sidecarPromotionLedgerHash: generatedSidecarPromotionLedger.ledgerHash,
      sidecarReadinessLedgerHash: generatedSidecarReadinessLedger.ledgerHash,
      runtimeValidationCampaignLedgerHash: generatedRuntimeValidationCampaignLedger.ledgerHash,
      runtimeClosurePacketHash: generatedRuntimeClosurePacket.packetHash,
      trajectoryValidationMatrixHash: generatedTrajectoryValidationMatrix.matrixHash,
      sidecarValidationReportHash: generatedSidecarValidationReport.reportHash,
      sidecarWorkOrderPacketHash: generatedSidecarWorkOrderPacket.packetHash,
      sidecarRunSpecPacketHash: generatedSidecarRunSpecPacket.packetHash,
      sidecarArtifactTemplatePacketHash: generatedSidecarArtifactTemplatePacket.packetHash,
      scenarioComparisonBoardHash: generatedScenarioComparisonBoard.boardHash,
      customerReportPacketLedgerHash: generatedCustomerReportPacketLedger.ledgerHash,
      customerReportExportManifestMode: generatedCustomerReportPacketLedger.reportExportManifest.mode,
      releaseEvidenceLedgerHash: generatedReleaseEvidenceLedger.ledgerHash,
      betaClosureStatusHash: generatedBetaClosureStatus.statusHash,
    },
    evidenceGapPriorityLedger: generatedEvidenceGapPriorityLedger,
    promotionClosureLedger: generatedPromotionClosureLedger,
    modelValidationProtocols: generatedModelValidationProtocolLedger,
    materialsProcessEvidenceLedger: generatedMaterialsProcessEvidenceLedger,
    spaceEnvironmentEvidenceLedger: generatedSpaceEnvironmentEvidenceLedger,
    scenarioDecisionAuditLedger: generatedScenarioDecisionAuditLedger,
    scenarioComparisonBoard: generatedScenarioComparisonBoard,
    scenarioCrossoverFrontierLedger: generatedScenarioCrossoverFrontierLedger,
    scenarioTraceabilityMatrix: generatedScenarioTraceabilityMatrix,
    sourcePromotionLedger: generatedSourcePromotionLedger,
    sourceUseClearanceDossier: generatedSourceUseClearanceDossier,
    sourceUseReviewPacket: generatedSourceUseReviewPacket,
    sourceUseRightsLedger: generatedSourceUseRightsLedger,
    businessPlatformRoadmap: generatedBusinessPlatformRoadmap,
    sidecarRunSpecPacket: generatedSidecarRunSpecPacket,
    sidecarArtifactTemplatePacket: generatedSidecarArtifactTemplatePacket,
    sidecarReadinessLedger: generatedSidecarReadinessLedger,
    runtimeValidationCampaignLedger: generatedRuntimeValidationCampaignLedger,
    runtimeClosurePacket: generatedRuntimeClosurePacket,
    trajectoryValidationMatrix: generatedTrajectoryValidationMatrix,
    sidecarPromotionLedger: generatedSidecarPromotionLedger,
    customerReportPacketLedger: generatedCustomerReportPacketLedger,
    customerReportExportManifest: generatedCustomerReportPacketLedger.reportExportManifest,
    releaseEvidenceLedger: generatedReleaseEvidenceLedger,
    betaClosureStatus: generatedBetaClosureStatus,
    allowedUse:
      "Decision-support and diligence package only; not an operational mission design, launch commitment, or verified resource claim.",
  };
}
